/**
 * Resolve a stored upload path (/uploads/...) to a full URL on the API host.
 * Relative paths on the SPA origin (e.g. ageonebg.com/uploads/…) serve index.html in production.
 */
export function uploadHref(path) {
    if (!path) return '';
    if (String(path).startsWith('http')) return path;

    const p = path.startsWith('/') ? path : `/${path}`;
    const backendOrigin = (import.meta.env.VITE_BACKEND_URL || '').replace(/\/$/, '');
    if (backendOrigin) return `${backendOrigin}${p}`;

    const apiUrl = import.meta.env.VITE_API_URL || '';
    if (apiUrl.startsWith('http')) {
        const root = apiUrl.replace(/\/api\/?$/i, '');
        return `${root}${p}`;
    }

    /* Same-origin deployment: only /api/* is proxied to the backend,
       so route uploads through the API prefix (served by the backend
       at /api/uploads as well). */
    return `/api${p}`;
}
